import React, { useState } from "react";
import { TextField, Button, Container, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import Nav from "react-bootstrap/Nav";
import API from "../utils/api";
import { Link } from "react-router-dom";
import Cookies from "js-cookie";

const useStyles = makeStyles({
  root: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "var(--section-background-color)", // Optional background color
  },
  container: {
    backgroundColor: "#1b1a2e",
    color: "white",
    padding: "24px",
    borderRadius: "8px",
    boxShadow: "0px 10px 10px 0px rgba(9, 5, 29, 0.171)",
    backdropFilter: "blur(15px)",
  },
  label: {
    color: "white",
    fontSize: "1.5rem",
    marginBottom: "16px",
  },
  textField: {
    paddingBottom: "16px",
    marginBottom: "16px",
    "& .MuiInputBase-root": {
      color: "white",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#934cce5e",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#a24dd386",
    },
    "& .MuiInputLabel-root": {
      color: "white",
    },
  },
  button: {
    backgroundColor: "#623686",
    color: "white",
    "&:hover": {
      backgroundColor: "#6d20c5d7",
    },
  },
});

const LoginComponent = (props) => {
  const classes = useStyles();
  const [password, setPassword] = useState("");
  const handleLoginClick = async () => {
    // Add your logic here
    try {
      await API.post("/api/login", {
        password: password,
      })
        .then((res) => res.data)
        .then((data) => {
          if (data.isAuthenticated) {
            // Set a cookie that expires in 1 hour
            Cookies.set("user_token", data.token, { expires: 1 / 24 });
            // localStorage.setItem("user_token", );
            console.log(data.token);
            props.setIsAuthenticated(true);
            props.setLearning(true);
          } else {
            alert("Error in Login", data.message);
          }
        });
    } catch (error) {
      console.error(error);
    }
  };
  const handleCancelClick = () => {
    // Add your logic here
    props.setLearning(false);
  };

  return (
    <div className={classes.root}>
      <Container maxWidth="xs" className={classes.container}>
        <Typography className={classes.label}>
          <h3>Login</h3>
        </Typography>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleLoginClick();
          }}
        >
          <TextField
            className={classes.textField}
            style={{
              paddingBottom: "16px",
              marginBottom: "16px",
              "& .MuiInputBase-root": {
                color: "white",
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#934cce5e",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "#a24dd386",
              },
              "& .MuiInputLabel-root": {
                color: "white",
              },
            }}
            label="Password"
            variant="outlined"
            type="password"
            fullWidth
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
            }}
          />
          <Button
            className={classes.button}
            variant="contained"
            style={{ backgroundColor: "#623686" }}
            fullWidth
            type="submit"
          >
            Submit
          </Button>
        </form>
        <Nav.Link as={Link} to="/" onClick={handleCancelClick}>
          Cancel
        </Nav.Link>
      </Container>
    </div>
  );
};

export default LoginComponent;
